export default [
  {
    path: "/platformConfigurations/receivingCountries",
    component: () => import(/* webpackChunkName: "layout" */ "../layout"),

    children: [
      {
        path: ":id",
        props: true,
        name: "platform.receivingCountries.show",
        component: () => import(/* webpackChunkName: "platform.receivingCountries" */ "./show.vue"),
      },
    ],
  },
];
